import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { getBannersCardapio, getLojaInfo } from '../services/api';
import { useCarrinho } from '../services/CarrinhoContext';
import BannerCarousel from '../components/BannerCarousel';
import NavigationMenu from '../components/NavigationMenu';
import Loading from '../components/Loading';

function Promocoes({ brand }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { itens } = useCarrinho();
  const [banners, setBanners] = useState([]);
  const [loja, setLoja] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    carregarDados();
  }, [brand]);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const [bannersData, lojaData] = await Promise.all([
        getBannersCardapio(brand),
        getLojaInfo(brand)
      ]);

      if (bannersData && Array.isArray(bannersData)) {
        setBanners(bannersData);
      } else if (bannersData?.data && Array.isArray(bannersData.data)) {
        setBanners(bannersData.data);
      }

      if (lojaData?.loja) {
        setLoja(lojaData.loja);
      }
    } catch (e) {
      // Erro silencioso
    } finally {
      setLoading(false);
    }
  };

  const handleMenuClick = (action) => {
    switch (action) {
      case 'cardapio':
        navigate('/');
        break;
      case 'loja':
        navigate('/loja');
        break;
      case 'promocoes':
        // Já está aqui
        break;
      default:
        break;
    }
  };

  if (loading) {
    return <Loading message="Carregando promoções..." />;
  }

  const isTablet = window.innerWidth >= 768;
  const tipoDevice = isTablet ? 'tablet' : 'mobile';
  const bannersDoDevice = banners.filter(b => b.tipo === tipoDevice).sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  const bannersParaExibir = bannersDoDevice.length > 0 ? bannersDoDevice : banners.sort((a, b) => (a.ordem || 0) - (b.ordem || 0));

  return (
    <div className="cardapio-page">
      {/* Header igual ao cardápio */}
      <div className="categorias-container" style={{ position: 'sticky', top: 0, zIndex: 1020, backgroundColor: '#f3f4f6', borderBottom: '1px solid #e5e7eb', boxShadow: '0 2px 6px rgba(0,0,0,0.03)' }}>
        <div className="categorias-content">
          <div className="categorias-topbar">
            <div className="categorias-brand">
              <Link to="/loja" className="categorias-logo-link" title={loja?.nome || 'Loja'}>
                <img
                  src={loja?.logo_url ? `https://grubupload.s3.amazonaws.com/${loja.logo_url}` : 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'}
                  alt={loja?.nome || 'Logo da loja'}
                  className="categorias-logo"
                  onError={(e) => { e.target.src = 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'; }}
                />
              </Link>
              <div className="categorias-loja-nome">
                {loja?.nome}
              </div>
            </div>
            <NavigationMenu
              onMenuClick={handleMenuClick}
              hasBanners={bannersParaExibir.length > 0}
              activeMenu={'promocoes'}
              lojaLogoUrl={loja?.logo_url}
              loja={loja}
            />
          </div>
        </div>
      </div>

      {/* Banner */}
      {bannersParaExibir.length > 0 ? (
        <div style={{ height: 'calc(100vh - 60px)', overflow: 'hidden' }}>
          <BannerCarousel banners={bannersParaExibir} autoPlayInterval={5000} />
          <style>{`
            .banner-carousel { height: 100% !important; }
            .banner-carousel-track { height: 100% !important; }
            .banner-carousel-slide { height: 100% !important; }
            .banner-carousel-slide img { width: 100%; height: 100%; object-fit: cover; }
          `}</style>
        </div>
      ) : (
        <div style={{ minHeight: '50vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <p style={{ color: '#666', fontSize: '16px' }}>Nenhuma promoção disponível no momento.</p>
          <button
            onClick={() => navigate('/')}
            style={{ marginTop: '16px', padding: '10px 24px', background: '#0039ff', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
          >
            Ver Cardápio
          </button>
        </div>
      )}
    </div>
  );
}

export default Promocoes;
